import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_LIST_CONNECTIONS,
    REQUEST_ADD_CONNECTION,
    REQUEST_UPDATE_CONNECTION,
    REQUEST_REMOVE_CONNECTION,
    REQUEST_SYNC_CONNECTION,
    REQUEST_LIST_CAMERAS,
    REQUEST_SYNC_SELECTED_CAMERAS,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/milestoneMsgDefinitions";
import {
    MilestoneConnectionHeader,
    MilestoneConnectionID,
    MilestoneCameraSyncRequest,
} from "userful-chronos-app-common-js/dist/models/integration/milestone";

import "./milestoneMsgReciever";

export const requestListConnections = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_CONNECTIONS);
};

export const requestAddConnection = (payload: MilestoneConnectionHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_CONNECTION, payload);
};

export const requestUpdateConnection = (payload: MilestoneConnectionHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_CONNECTION, payload);
};

export const requestRemoveConnection = (payload: MilestoneConnectionID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_CONNECTION, payload);
};

export const requestSyncConnection = (payload: MilestoneConnectionID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SYNC_CONNECTION, payload);
};

export const requestListCameras = (payload: MilestoneConnectionID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_CAMERAS, payload);
};

export const requestSyncSelectedCameras = (payload: MilestoneCameraSyncRequest) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SYNC_SELECTED_CAMERAS, payload);
};
